import {api} from '../components/Base/App';
import axios from 'axios';

export default {
    bookingCalculate(objectId, rentCalculationCommand, getCancel) {
        let CancelToken = axios.CancelToken;
        let source = CancelToken.source();

        if (getCancel !== undefined) {
            getCancel(source);
        }

        return api({
            method: 'get',
            url: '/rest/api/calculate',
            cancelToken: source.token,

            params: {
                objectId: objectId,
                arrival: rentCalculationCommand.dateStart,
                exit: rentCalculationCommand.dateEnd,
                countGuest: rentCalculationCommand.countGuests,
                addTaxToTotal: true
            }
        });
    },

    getCalendars(objectId, calendarSearchCommand, getCancel) {
        let CancelToken = axios.CancelToken;
        let source = CancelToken.source();

        if (getCancel !== undefined) {
            getCancel(source);
        }

        const params = new URLSearchParams();
        if (calendarSearchCommand !== undefined) {
            params.append('endDate', calendarSearchCommand.endDate);
            params.append('startDate', calendarSearchCommand.startDate);
        }

        return api({
            method: 'get',
            url: `/rest/calendars/calendar/${objectId}`,
            cancelToken: source.token,
            params: params
        });
    },

    update(objectId, updateDaysCommand) {
        return api({
            method: 'post',
            url: `/rest/calendars/calendar/${objectId}`,
            data: updateDaysCommand
        })
    }
};



// WEBPACK FOOTER //
// ./src/api/Calendars.js